const tripDetailsAfDpFactory = require('components/user_area/open_ticket/js/tripdetails_afdp_factory');

const addBookingDataParameters = ({baseUrl, bookingData}) => {
    const bookingId = bookingData?.bookingBasicInfo?.id;
    const mail = bookingData?.buyer?.mail;
    if (!mail || !bookingId) {
        return baseUrl;
    }
    const brand = Odigeo.SessionScope.brand;
    const encodedAfdp = tripDetailsAfDpFactory.tripDetailsAfDpFactory({brand, email: mail, bookingId});
    return replaceBookingDataParameters({baseUrl, afdp: encodedAfdp});
};
const replaceBookingDataParameters = ({baseUrl, afdp}) => {
    return Odigeo.Utils.replaceCmsKeyArgs(baseUrl, afdp);
};

module.exports = {
    addBookingDataParameters: addBookingDataParameters,
};
